if (!customElements.get('features-slider')) {
	customElements.define('features-slider', class FeaturesSlider extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.carousel = this.querySelector('.media-icon-items-grid');
				this.initialize();
			}

			initialize() {
				const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';

				this.flickity = new Flickity(this.carousel, {
					autoPlay: autoplayEnabled ? 3500 : false,
					cellAlign: 'center',
					groupCells: false,
					contain: true,
					resize: true,
					draggable: true,
					prevNextButtons: false,
					cellSelector: '.media-icon-item',
					initialIndex: 0,
					pageDots: false,
					wrapAround: true,
					accessibility: false,
					watchCSS: true,
				});
			}
		}
	);
}
